<div class="map-drawer-container">
  <div class="top" [ngClass]="{ 'drawer-open-state': isMapLayersDrawerOpen }">
    @if (enableMapTypeToggle) {
      <rdx-snow-orv-toggle
        id="sno-orv-toggle-header"
        class="sno-orv-toggle-header"
        [rideType]="isMapTypeSno ? 'snow' : 'orv'"
        [showIcon]="true"
      />
    }
    <a
      id="toggleShowOnMapDrawer"
      class="top-container"
      href="javascript:void(0);"
      (click)="toggleMapLayersDrawerVisibility()"
    >
      <img class="map-layers-icon" alt="Map Layers" ngSrc="/assets/icons/layers.svg" i18n-alt />
      <div class="layers-on-list-container">
        <rdx-map-tools-selected-group-summary
          [isLayersGroup]="true"
          [limit]="4"
          [brand]="brand"
          [selectedItems]="activeLayers"
        />
        <svg-icon
          src="/assets/icons/rightarrow.svg"
          svgAriaLabel="toggle drawer"
          [svgClass]="isMapLayersDrawerOpen ? 'collapse-icon' : 'open-icon'"
          i18n-svgAriaLabel
        />
      </div>
    </a>
  </div>

  @if (isMapLayersDrawerOpen) {
    <div class="bottom">
      <div class="layers-list-container">
        <div class="inner-layers-list-container">
          @if (!isMapTypeDrawerOpen) {
            <ul class="layer-group list-unstyled">
              @if (enableMapTypeToggle && !isMapTypeSno) {
                <li class="layer-container has-options-layer-container">
                  <div class="icon">
                    <svg-icon src="/assets/icons/map-icons/shared/trails.svg" svgAriaLabel="trails" i18n-svgAriaLabel />
                  </div>
                  <div class="label" i18n>Trails</div>
                  <div class="options-row">
                    <a id="openTrailTypeToggle" href="javascript: void(0);" (click)="toggleTrailTypeDrawer()">
                      <svg-icon
                        class="svg-icon-themed"
                        src="/assets/icons/orv.svg"
                        svgAriaLabel="off-road"
                        i18n-svgAriaLabel
                      />
                      <span class="helper-bold" i18n> Off-Road</span>
                      <svg-icon
                        class="trails-right-arrow"
                        src="/assets/icons/rightarrow.svg"
                        svgAriaLabel="expand"
                        i18n-svgAriaLabel
                      />
                    </a>
                    <div class="vl"></div>
                  </div>
                  <div class="toggle">
                    <mat-slide-toggle
                      id="toggleTrails"
                      aria-label="Toggle Trails"
                      [checked]="isShowingTrails"
                      [hideIcon]="true"
                      (change)="setIsShowingTrails($event.checked)"
                      i18n-aria-label
                    />
                  </div>
                </li>
              }
              @if (isTrailDifficultyEnabled && isShowingTrails && !isMapTypeSno) {
                <li class="layer-container two-row">
                  <div class="icon">
                    <svg-icon src="/assets/icons/trail-difficulty.svg" svgAriaLabel="Satellite" i18n-svgAriaLabel />
                  </div>
                  <div class="label">
                    <div i18n>Trail Difficulty</div>
                    <div class="helper-secondary-text" i18n>Where Available</div>
                  </div>
                  <div class="toggle">
                    <mat-slide-toggle
                      id="toggleTrailDifficulty"
                      aria-label="Toggle Trail Difficulty"
                      [checked]="isShowingTrailDifficulty"
                      [hideIcon]="true"
                      (change)="setTrailDifficulty($event.checked)"
                      i18n-aria-label
                    />
                  </div>
                </li>
              }

              @if (!isMapTypeSno && isHazardReportingEnabled) {
                <ul class="layer-group list-unstyled mini-group">
                  <li class="layer-container">
                    <div class="icon">
                      <svg-icon
                        src="/assets/icons/alert-triangle.svg"
                        svgAriaLabel="Trail Condition"
                        i18n-svgAriaLabel
                      />
                    </div>
                    <div class="label" i18n>Trail Conditions</div>
                    <div class="toggle">
                      <mat-slide-toggle
                        id="toggleRideConditions"
                        aria-label="Toggle Trail Conditions"
                        [checked]="isShowingOffRoadRideCondition"
                        [hideIcon]="true"
                        (change)="setOffRoadRideConditions($event.checked)"
                        i18n-aria-label
                      />
                    </div>
                  </li>
                  @if (isShowingOffRoadRideCondition) {
                    <li class="conditions-slider">
                      <div class="conditions-label">
                        <span>{{ $offRideConditionSliderLabel() }}</span>
                      </div>
                      <div class="slider-container">
                        <mat-slider #ngSlider id="conditionsSlider" [max]="720" [min]="24" [step]="1"
                          ><input
                            #ngSliderThumb="matSliderThumb"
                            matSliderThumb
                            [value]="$maxOffRideConditionAgeInHours()"
                            (input)="setOffRideConditionsSliderLabel(ngSliderThumb.value)"
                            (change)="setOffRideConditionsDuration(ngSliderThumb.value)"
                          />
                        </mat-slider>
                      </div>
                    </li>
                  }
                </ul>
              }
              @if (enableMapTypeToggle && isMapTypeSno) {
                <li class="layer-container has-options-layer-container">
                  <div class="icon">
                    <svg-icon src="/assets/icons/map-icons/shared/trails.svg" svgAriaLabel="trails" i18n-svgAriaLabel />
                  </div>
                  <div class="label" i18n>Trails</div>
                  <div class="options-row">
                    <a id="openTrailTypeToggleSnow" href="javascript: void(0);" (click)="toggleTrailTypeDrawer()">
                      <svg-icon
                        class="svg-icon-themed"
                        src="/assets/icons/snow.svg"
                        svgAriaLabel="off-road"
                        i18n-svgAriaLabel
                      />
                      <span class="helper-bold" i18n> Snow</span>
                      <svg-icon
                        class="trails-right-arrow"
                        src="/assets/icons/rightarrow.svg"
                        svgAriaLabel="expand"
                        i18n-svgAriaLabel
                      />
                    </a>
                    <div class="vl"></div>
                  </div>
                  <div class="toggle">
                    <mat-slide-toggle
                      id="toggleTrailsSnow"
                      aria-label="Toggle Trails"
                      [checked]="isShowingTrails"
                      [hideIcon]="true"
                      (change)="setIsShowingTrails($event.checked)"
                      i18n-aria-label
                    />
                  </div>
                </li>
              }

              @if (isMapTypeSno && isHazardReportingEnabled) {
                <ul class="layer-group list-unstyled mini-group">
                  <li class="layer-container">
                    <div class="icon">
                      <svg-icon src="/assets/icons/condition.svg" svgAriaLabel="Snow Condition" i18n-svgAriaLabel />
                    </div>
                    <div class="label" i18n>Snow Conditions</div>
                    <div class="toggle">
                      <mat-slide-toggle
                        id="toggleRideConditions"
                        aria-label="Toggle Snow Conditions"
                        [checked]="isShowingSnowRideCondition"
                        [hideIcon]="true"
                        (change)="setSnowRideConditions($event.checked)"
                        i18n-aria-label
                      />
                    </div>
                  </li>
                  @if (isShowingSnowRideCondition) {
                    <li class="conditions-slider">
                      <div class="conditions-label">
                        <span>{{ $snowRideConditionSliderLabel() }}</span>
                      </div>
                      <div class="slider-container">
                        <mat-slider #ngSlider id=" conditionsSlider" [max]="168" [min]="2" [step]="1"
                          ><input
                            #ngSliderThumb="matSliderThumb"
                            matSliderThumb
                            [value]="$maxSnowRideConditionAgeInHours()"
                            (input)="setSnowRideConditionSliderLabel(ngSliderThumb.value)"
                            (change)="setSnowRideConditionsDuration(ngSliderThumb.value)"
                          />
                        </mat-slider>
                      </div>
                    </li>
                  }
                </ul>
              }

              @if (isMapTypeSno && !isHazardReportingEnabled) {
                <ul class="layer-group list-unstyled mini-group">
                  <li class="layer-container">
                    <div class="icon">
                      <svg-icon src="/assets/icons/condition.svg" svgAriaLabel="Snow Condition" i18n-svgAriaLabel />
                    </div>
                    <div class="label" i18n>Snow Conditions</div>
                    <div class="toggle">
                      <mat-slide-toggle
                        id="toggleRideConditions"
                        aria-label="Toggle Snow Conditions"
                        [checked]="isShowingRideCondition"
                        [hideIcon]="true"
                        (change)="setRideConditions($event.checked)"
                        i18n-aria-label
                      />
                    </div>
                  </li>
                  @if (isShowingRideCondition) {
                    <li class="conditions-slider">
                      <div class="conditions-label" [ngClass]="{ disabled: !isShowingRideCondition }">
                        <span i18n>Hide conditions older than</span>
                        <span class="helper-bold">&nbsp;{{ rideConditionSliderLabel$ | async }}</span>
                      </div>
                      <div class="slider-container">
                        <mat-slider
                          #ngSlider
                          id=" conditionsSlider"
                          [disabled]="!isShowingRideCondition"
                          [ngModel]="maxRideConditionAgeInHours$ | async"
                          [max]="168"
                          [min]="2"
                          [step]="1"
                          ><input
                            #ngSliderThumb="matSliderThumb"
                            matSliderThumb
                            [value]="maxRideConditionAgeInHours$ | async"
                            (input)="maxRideConditionAgeLabelSubject.next(ngSliderThumb.value)"
                            (change)="setRideConditionsDuration(ngSliderThumb.value)"
                          />
                        </mat-slider>
                      </div>
                    </li>
                  }
                </ul>
              }
              @if (isHeatMapEnabled) {
                <li class="layer-container two-row">
                  <div class="icon heatmap">
                    @if (isMapTypeSno) {
                      @if (isShowingSatellite) {
                        <img
                          alt="Map type is Snow type with satellite view."
                          aria-label="Snow Satellite Ride Heatmap"
                          ngSrc="/assets/icons/open-ride-area-snow-sm-sat.svg"
                          i18n-alt
                          i18n-aria-label
                        />
                      } @else {
                        <img
                          alt="Map type is Snow style with a regular map view."
                          aria-label="Snow Map Ride Heatmap"
                          ngSrc="/assets/icons/open-ride-area-snow-sm.svg"
                          i18n-alt
                          i18n-aria-label
                        />
                      }
                    } @else {
                      @if (isShowingSatellite) {
                        <img
                          alt="Map type is Off-Road style with satellite view."
                          aria-label="Offroad Satellite Ride Heatmap"
                          ngSrc="/assets/icons/open-ride-area-off-road-sm-sat.svg"
                          i18n-alt
                          i18n-aria-label
                        />
                      } @else {
                        <img
                          alt="Map type is Off-Road style with a regular map view."
                          aria-label="offroad Map Satellite Ride Heatmap"
                          ngSrc="/assets/icons/open-ride-area-off-road-sm.svg"
                          i18n-alt
                          i18n-aria-label
                        />
                      }
                    }
                  </div>
                  <div class="label">
                    <div i18n>Heatmap</div>
                    <div class="helper-secondary-text" i18n>Popular tracks in open ride areas</div>
                  </div>
                  <div class="toggle">
                    <mat-slide-toggle
                      id="toggleHeatmap"
                      aria-label="Toggle Satellite Map"
                      [checked]="isShowingHeatmap"
                      [hideIcon]="true"
                      (change)="setIsShowingHeatmap($event.checked)"
                      i18n-aria-label
                    />
                  </div>
                </li>
              }
            </ul>

            <hr />
            <ul class="layer-group list-unstyled">
              <li class="layer-container">
                <div class="icon">
                  <svg-icon
                    src="/assets/icons/map-icons/shared/satellite.svg"
                    svgAriaLabel="Satellite"
                    i18n-svgAriaLabel
                  />
                </div>
                <div class="label" i18n>Satellite Map</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleSatelliteMap"
                    aria-label="Toggle Satellite Map"
                    [checked]="isShowingSatellite"
                    [hideIcon]="true"
                    (change)="setIsShowingSatellite($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              <li class="layer-container">
                <div class="icon">
                  <svg-icon src="/assets/icons/radar.svg" alt="Radar Weather" i18n-alt />
                </div>
                <div class="label" i18n>Radar Weather</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleRadar"
                    aria-label="Toggle Radar"
                    [checked]="isShowingRadarWeather"
                    [hideIcon]="true"
                    (change)="setIsShowingRadarWeather($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              @if (isMapTypeSno) {
                <li class="layer-container">
                  <div class="icon">
                    <svg-icon src="/assets/icons/snow-depth.svg" alt="Snow Depth" i18n-alt />
                  </div>
                  <div class="label" i18n>Snow Depth</div>
                  <div class="toggle">
                    <mat-slide-toggle
                      id="toggleSnowDepth"
                      aria-label="Toggle Snow Depth"
                      [checked]="isShowingSnowDepth"
                      [hideIcon]="true"
                      (change)="setIsShowingSnowDepth($event.checked)"
                      i18n-aria-label
                    />
                  </div>
                </li>
              }
              <li class="layer-container">
                <div class="icon">
                  <svg-icon src="/assets/icons/cloud.svg" alt="Ride" i18n-alt />
                </div>
                <div class="label" i18n>Cloud Cover</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleCloudCover"
                    aria-label="Toggle Cloud Cover"
                    [checked]="isShowingCloudCover"
                    [hideIcon]="true"
                    (change)="setIsShowingCloudCover($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              @if (isLandInfoEnabled) {
                <li class="layer-container">
                  <div class="icon">
                    <svg-icon src="/assets/icons/info-filled.svg" alt="Land Information" i18n-alt />
                  </div>
                  <div class="label" i18n>Landowner / County Lines</div>
                  <div class="toggle">
                    <mat-slide-toggle
                      id="toggleLand"
                      aria-label="Toggle Land"
                      rdcAnalytics="Land Areas toggle"
                      [rdcAnalyticsData]="`switch${isShowingLandInfo ? 'ON' : 'OFF'}`"
                      [hideIcon]="true"
                      [checked]="isShowingLandInfo"
                      (change)="setIsShowingLandInfo($event.checked)"
                      i18n-aria-label
                    />
                  </div>
                </li>
              }
            </ul>

            <hr />

            <ul class="layer-group list-unstyled">
              <li class="layer-container">
                <div class="icon">
                  <svg-icon
                    class="tracked-ride-icon"
                    src="/assets/icons/map-icons/shared/tracked-ride.svg"
                    alt="Ride"
                    i18n-alt
                  />
                </div>
                <div class="label" i18n>Tracked Rides</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleTrackedRides"
                    aria-label="Toggle Tracked Rides"
                    [checked]="isShowingTrackedRides"
                    [hideIcon]="true"
                    (change)="setIsShowingTrackedRides($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>

              @if (hasViewCurrentRidePermission) {
                <li class="layer-container">
                  <div class="icon">
                    <svg-icon
                      class="tracked-ride-icon"
                      src="/assets/icons/map-icons/shared/tracked-ride.svg"
                      alt="Ride"
                      i18n-alt
                    />
                  </div>
                  <div class="label" i18n>Current Ride Track</div>
                  <div class="toggle">
                    <mat-slide-toggle
                      id="toggleInProgressRide"
                      aria-label="Toggle In Progress Ride"
                      [checked]="isShowingInProgressRide"
                      [hideIcon]="true"
                      (change)="setIsShowingInProgressRideTrack($event.checked)"
                      i18n-aria-label
                    />
                  </div>
                </li>
              }
              <li class="layer-container">
                <div class="icon">
                  <svg-icon
                    class="planned-ride-icon"
                    src="/assets/icons/map-icons/shared/planned-ride.svg"
                    alt="Route"
                    i18n-alt
                  />
                </div>
                <div class="label" i18n>Routes</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="togglePlannedRides"
                    aria-label="Toggle Routes"
                    [checked]="isShowingPlannedRides"
                    [hideIcon]="true"
                    (change)="setIsShowingPlannedRides($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              <li class="layer-container">
                <div class="icon">
                  <svg-icon
                    class="waypoint-icon"
                    src="/assets/icons/map-icons/shared/waypoint.svg"
                    alt="Waypoint"
                    i18n-alt
                  />
                </div>
                <div class="label" i18n>Places</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleSavedPlaces"
                    aria-label="Toggle Places"
                    [checked]="isShowingWaypoints"
                    [hideIcon]="true"
                    (change)="setIsShowingWaypoints($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              @if (enableMapTypeToggle && areGeofencesEnabled) {
                <li class="layer-container">
                  <div class="icon">
                    <svg-icon
                      class="geofence-icon"
                      src="/assets/icons/map-icons/shared/geofence.svg"
                      alt="Areas"
                      i18n-alt
                    />
                  </div>
                  <div class="label" i18n>Areas</div>
                  <div class="toggle">
                    <mat-slide-toggle
                      id="toggleAreas"
                      aria-label="Toggle Areas"
                      [checked]="isShowingGeofences"
                      [hideIcon]="true"
                      (change)="setIsShowingGeofences($event.checked)"
                      i18n-aria-label
                    />
                  </div>
                </li>
              }
            </ul>

            <hr />

            <ul class="layer-group list-unstyled">
              <li class="layer-container">
                <div class="icon">
                  <svg-icon alt="Dealer" [src]="`/assets/icons/map-icons/${brand}/poi-dealer.svg`" i18n-alt />
                </div>
                <div class="label" i18n>Dealers</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleDealers"
                    aria-label="Toggle Dealers"
                    [checked]="isShowingDealers"
                    [hideIcon]="true"
                    (change)="setIsShowingDealers($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              <li class="layer-container">
                <div class="icon">
                  <svg-icon alt="Adventures" [src]="`/assets/icons/map-icons/${brand}/adventures.svg`" i18n-alt />
                </div>
                <div class="label" i18n>Polaris Adventures</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleAdventures"
                    aria-label="Toggle Adventures"
                    [checked]="isShowingAdventures"
                    [hideIcon]="true"
                    (change)="setIsShowingAdventures($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              <li class="layer-container">
                <div class="icon">
                  <svg-icon src="/assets/icons/map-icons/shared/poi-food.svg" alt="Food" i18n-alt />
                </div>
                <div class="label" i18n>Food</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleFood"
                    aria-label="Toggle Food"
                    [checked]="isShowingFoodPlaces"
                    [hideIcon]="true"
                    (change)="setIsShowingFood($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              <li class="layer-container">
                <div class="icon">
                  <svg-icon src="/assets/icons/map-icons/shared/poi-fuel.svg" alt="Fuel" i18n-alt />
                </div>
                <div class="label" i18n>Gas</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleGas"
                    aria-label="Toggle Gas"
                    [checked]="isShowingFuelPlaces"
                    [hideIcon]="true"
                    (change)="setIsShowingFuel($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              <li class="layer-container">
                <div class="icon">
                  <svg-icon src="/assets/icons/map-icons/shared/poi-lodging.svg" alt="Lodging" i18n-alt />
                </div>
                <div class="label" i18n>Lodging</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleLodging"
                    aria-label="Toggle Lodging"
                    [checked]="isShowingLodgingPlaces"
                    [hideIcon]="true"
                    (change)="setIsShowingLodging($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
              <li class="layer-container">
                <div class="icon">
                  <svg-icon src="/assets/icons/map-icons/shared/poi-other.svg" alt="Other" i18n-alt />
                </div>
                <div class="label" i18n>Other</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleOther"
                    aria-label="Toggle Other"
                    [checked]="isShowingUnknownPlaces"
                    [hideIcon]="true"
                    (change)="setIsShowingUnknown($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </li>
            </ul>
          }

          @if (isMapTypeDrawerOpen) {
            <div class="trail-type-chooser-container">
              <a
                id="toggleTrailTypeDrawer"
                class="header-nav"
                href="javascript: void(0);"
                (click)="toggleTrailTypeDrawer()"
              >
                <svg-icon class="back-icon" src="/assets/icons/backarrow.svg" alt="Go Back" i18n-alt />
                <div><strong i18n>Trails</strong></div>
              </a>

              <div class="trail-filter-toggle-container">
                <div class="helper-bold" i18n>Show Trails</div>
                <div class="toggle">
                  <mat-slide-toggle
                    id="toggleTrailFilter"
                    aria-label="Toggle Trails"
                    [checked]="isShowingTrails"
                    [hideIcon]="true"
                    (change)="setIsShowingTrails($event.checked)"
                    i18n-aria-label
                  />
                </div>
              </div>

              @if (isShowingTrails) {
                <div class="toggle-container">
                  @if (enableMapTypeToggle) {
                    <rdx-snow-orv-toggle
                      id="sno-orv-toggle-drawer"
                      [rideType]="isMapTypeSno ? 'snow' : 'orv'"
                      [showIcon]="true"
                      [showTitle]="true"
                    />
                  }
                </div>

                @if (isMapTypeSno) {
                  <rdx-snow-trail-list [isShowingSatellite]="isShowingSatellite" />
                } @else {
                  <rdx-offroad-trail-list [isShowingSatellite]="isShowingSatellite" />
                }
              } @else {
                <div class="show-trails-message" i18n>Flip the switch above to turn trails on.</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
